export var ApiServiceLevelEnum;
(function (ApiServiceLevelEnum) {
    ApiServiceLevelEnum["FREE"] = "free";
    ApiServiceLevelEnum["PRO"] = "pro";
    ApiServiceLevelEnum["BUSINESS"] = "business";
    ApiServiceLevelEnum["ENTERPRISE"] = "enterprise";
    ApiServiceLevelEnum["UNLIMITED"] = "unlimited";
})(ApiServiceLevelEnum || (ApiServiceLevelEnum = {}));
export var StripeBillingIntervalEnum;
(function (StripeBillingIntervalEnum) {
    StripeBillingIntervalEnum["MONTH"] = "month";
    StripeBillingIntervalEnum["YEAR"] = "year";
})(StripeBillingIntervalEnum || (StripeBillingIntervalEnum = {}));
export var ProductUseCasesEnum;
(function (ProductUseCasesEnum) {
    ProductUseCasesEnum["IN_APP"] = "in_app";
    ProductUseCasesEnum["MULTI_CHANNEL"] = "multi_channel";
    ProductUseCasesEnum["DELAY"] = "delay";
    ProductUseCasesEnum["TRANSLATION"] = "translation";
    ProductUseCasesEnum["DIGEST"] = "digest";
    ProductUseCasesEnum["AGENTS"] = "agents";
})(ProductUseCasesEnum || (ProductUseCasesEnum = {}));
export var IndustryEnum;
(function (IndustryEnum) {
    IndustryEnum["ECOMMERCE"] = "ecommerce";
    IndustryEnum["FINTECH"] = "fintech";
    IndustryEnum["SAAS"] = "saas";
    IndustryEnum["HEALTHCARE"] = "healthcare";
    IndustryEnum["EDUCATION"] = "education";
    IndustryEnum["MEDIA"] = "media";
    IndustryEnum["MARKETPLACE"] = "marketplace";
    IndustryEnum["GAMING"] = "gaming";
    IndustryEnum["TRAVEL"] = "travel";
    IndustryEnum["REAL_ESTATE"] = "real_estate";
    IndustryEnum["LOGISTICS"] = "logistics";
    IndustryEnum["FOOD_AND_BEVERAGE"] = "food_and_beverage";
    IndustryEnum["INSURANCE"] = "insurance";
    IndustryEnum["GOVERNMENT"] = "government";
    IndustryEnum["NON_PROFIT"] = "non_profit";
    IndustryEnum["TELECOMMUNICATIONS"] = "telecommunications";
    IndustryEnum["RETAIL"] = "retail";
    IndustryEnum["AUTOMOTIVE"] = "automotive";
    IndustryEnum["CONSTRUCTION"] = "construction";
    IndustryEnum["ENERGY"] = "energy";
    IndustryEnum["AGRICULTURE"] = "agriculture";
    IndustryEnum["LEGAL"] = "legal";
    IndustryEnum["OTHER"] = "other";
})(IndustryEnum || (IndustryEnum = {}));
//# sourceMappingURL=organization.js.map